import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '@goodday-clone/ui'
import { Users2, UserCheck, Briefcase, ArrowLeft } from 'lucide-react'

export default function ResourcesPage() {
  const navigate = useNavigate()
  return (
    <div className="space-y-6 max-w-full mx-auto">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex items-center gap-3.5">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-tr from-[#6825F5] to-[#7C3AED] text-white shadow-sm shadow-purple-200 transition-all hover:shadow-md hover:shadow-purple-300/50"
            aria-label="Back"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
              <Users2 className="h-6 w-6 text-primary" />
              Resources
            </h1>
            <p className="text-sm text-muted-foreground">Manage team capacity, workload, and resource allocation</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[
          { label: 'Team Members', value: '—', icon: UserCheck },
          { label: 'Active Projects', value: '—', icon: Briefcase },
          { label: 'Avg. Utilization', value: '—', icon: Users2 },
        ].map(({ label, value, icon: Icon }) => (
          <Card key={label}>
            <CardContent className="pt-6">
              <div className="flex items-center gap-3">
                <div className="p-2 rounded-lg bg-primary/10">
                  <Icon className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground">{label}</p>
                  <p className="text-2xl font-bold text-foreground">{value}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Resource Utilization</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-center justify-center min-h-[250px] text-muted-foreground gap-3">
            <Users2 className="h-12 w-12 opacity-30" />
            <p className="text-sm font-medium">No resource data available</p>
            <p className="text-xs">Assign tasks to team members to track utilization</p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
